import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getWorkerList } from 'components/worker/WorkerAPI';
import { setWorkerList, setWorkerDashboardWorkerList } from 'store/slice/ManufSlice';
import WorkerDashboard from '../WorkerDashboard';
import { getListAPI as getSkillList} from 'components/skill/SkillAPI';
import { setSkillList } from 'store/slice/ManufSlice';


export default function WorkerPageImpl() {
    const dispatch = useDispatch();
    const { workerList} = useSelector((state)=>state.manufslice);
    
    const getWorkerListSuccess = (list) =>{dispatch(setWorkerList(list));}
    const getSkillListSuccess = (list) =>{dispatch(setSkillList(list));}
    useEffect(() => {
        getWorkerList(()=>{}, getWorkerListSuccess);
        getSkillList(()=>{}, getSkillListSuccess); // Fetch skills, if needed
    },[]);
    useEffect(()=>{
        dispatch(setWorkerDashboardWorkerList( workerList));
    },[ workerList])

    return (
        < WorkerDashboard />
    )

}